<mat-toolbar color="primary" class="toolbar">

  <!-- Left: Navigation menu button + emblem -->
  <div class="left-section">
    <button mat-button (click)="toggleSidenav.emit()" class="nav-button">
      <mat-icon>menu</mat-icon>
    </button>
    <div *ngIf="!hideBannerEmblems" class="left-emblem">
      <img *ngIf="!agencyEmblem" src="assets/images/eu-emblem-with-text.png" alt="EU emblem" class="agency-custom-logo">
      <img *ngIf="agencyEmblem" [src]="agencyEmblem" alt="Agency emblem" class="agency-custom-logo">
    </div>
  </div>

  <!-- Center: Title with flags -->
  <div class="center-section">
    <p class="title-top">Electronic Readmission</p>
    <p class="title-bottom">Case Management System</p>
  </div>

  <!-- Right: Action buttons -->
  <div class="action-buttons">
    <span class="fi fi-{{flagCountryCode}} flag"></span>
    <button mat-icon-button matTooltip="{{'HEADER.SYSTEM_STATUS' | translate}}" (click)="openSystemStatus()">
      <mat-icon *ngIf="systemStatusList" [ngStyle]="{'color': systemStatusList.statusColor}">circle</mat-icon>
    </button>

    <select #selLang (change)="switchLang(selLang.value)" class="language-select">
      <option *ngIf="translate.currentLang" disabled selected hidden>
        {{ translate.currentLang | languageCodeToName }}
      </option>
      <option *ngIf="!translate.currentLang" disabled selected hidden>
        {{ translate.getDefaultLang()| languageCodeToName }}
      </option>
      <option *ngFor="let language of translate.getLangs()" [value]="language">
        {{ language | languageCodeToName }}
      </option>
    </select>

    <button mat-icon-button routerLink="/help-center">
      <mat-icon>help</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
      <mat-icon>notifications_none</mat-icon>
      <span [matBadgeHidden]="notificationsCount == 0" [matBadge]="notificationsCount" matBadgeOverlap="false"
        matBadgeColor="accent"></span>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="profileMenu">
      <mat-icon>perm_identity</mat-icon>
    </button>
  </div>

  <!-- Menus -->
  <mat-menu #notificationMenu="matMenu">
    <app-notification-box></app-notification-box>
  </mat-menu>

  <mat-menu #profileMenu="matMenu">
    <span *ngIf="loggedInUserName" class="user-name">{{loggedInUserName}}</span>
    <button mat-menu-item (click)="openNotificationPreferences()">
      {{"NOTIFICATION_PREFERENCES.NOTIFICATION_PREFERENCES" | translate}}
    </button>
    <button mat-menu-item (click)="changePassword()">
      {{"ACTIONS.CHANGE_PASSWORD" | translate}}
    </button>
    <button mat-menu-item (click)="logout()">
      {{"ACTIONS.LOG_OUT" | translate }}
    </button>
  </mat-menu>

</mat-toolbar>
